import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementCard = ({ achievement }) => {
  const { title, description, icon, isUnlocked, unlockedDate, progress, category, rarity } = achievement;

  const getRarityColor = (rarity) => {
    switch (rarity) {
      case 'common':
        return 'text-muted-foreground bg-muted';
      case 'rare':
        return 'text-primary bg-primary/10';
      case 'epic':
        return 'text-secondary bg-secondary/10';
      case 'legendary':
        return 'text-accent bg-accent/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getRarityLabel = (rarity) => {
    switch (rarity) {
      case 'common':
        return 'Comum';
      case 'rare':
        return 'Raro';
      case 'epic':
        return 'Épico';
      case 'legendary':
        return 'Lendário';
      default:
        return 'Comum';
    }
  };

  return (
    <div className={`bg-card rounded-lg border border-border p-6 transition-micro hover:shadow-tier-2 ${
      isUnlocked ? '' : 'opacity-60'
    }`}>
      <div className="flex items-start justify-between mb-4">
        <div className={`w-16 h-16 rounded-full flex items-center justify-center ${
          isUnlocked ? getRarityColor(rarity) : 'bg-muted text-muted-foreground'
        }`}>
          <Icon 
            name={icon} 
            size={32} 
            className={isUnlocked ? '' : 'opacity-50'} 
          />
        </div>
        <div className="flex flex-col items-end space-y-2">
          <div className={`px-2 py-1 rounded-full text-xs font-medium ${getRarityColor(rarity)}`}>
            {getRarityLabel(rarity)}
          </div>
          {isUnlocked && (
            <div className="flex items-center space-x-1 text-success">
              <Icon name="CheckCircle" size={16} />
              <span className="text-xs font-medium">Desbloqueado</span>
            </div>
          )}
        </div>
      </div>

      <div className="mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
          {title}
        </h3>
        <p className="text-sm text-muted-foreground font-caption">
          {description}
        </p>
      </div>

      {isUnlocked ? (
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="Calendar" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground font-caption">
              Desbloqueado em {unlockedDate}
            </span>
          </div>
          <div className="flex items-center space-x-1 text-secondary">
            <Icon name="Star" size={16} />
            <span className="text-sm font-medium">Conquista</span>
          </div>
        </div>
      ) : (
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-foreground">Progresso</span>
            <span className="text-sm text-muted-foreground font-caption">
              {progress?.current || 0}/{progress?.total || 1}
            </span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div
              className="bg-primary h-2 rounded-full transition-all duration-500"
              style={{ 
                width: `${((progress?.current || 0) / (progress?.total || 1)) * 100}%` 
              }}
            />
          </div>
        </div>
      )}

      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          <Icon name="Tag" size={14} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground font-caption capitalize">
            {category}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AchievementCard;